import { AutomationTypeEnum, RunIntervalEnum } from "../enums";

export default {
  isActive(automation) {
    return automation.active;
  },
  isInactive(automation) {
    return !automation.active;
  },
  isOneTimeDataEnrichment(automation) {
    return automation.type === AutomationTypeEnum.DATA_ENRICHMENT
      && automation.run_interval === RunIntervalEnum.ONCE;
  },
};
